"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const InvoiceItemTypes_1 = require("../../../types/InvoiceItemTypes");
const useStyle = ({ fontSize, tipLabelType, selected, blackThemeStyle }) => {
    const Theme = (0, material_1.useTheme)();
    const noTipLabelIcon = Object.assign({ fontSize }, (blackThemeStyle && {
        color: '#C5C5C5 !important',
    }));
    const includeTipLabelIcon = Object.assign({ fontSize, color: selected ? Theme.palette.primary.contrastText : Theme.palette.primary.main }, (tipLabelType === InvoiceItemTypes_1.TipLabelTypeEnum.Stars && {
        color: '#FFCC00',
    }));
    return {
        includeTipLabelIcon,
        noTipLabelIcon,
    };
};
exports.default = useStyle;
